/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Card_Ai_Team_ValueInputs */



/**
* | output |
* | --- |
* | "€5/user/mo included credits" |
*
* @param {Plan_Card_Ai_Team_ValueInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_card_ai_team_value = /** @type {((inputs?: Plan_Card_Ai_Team_ValueInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Card_Ai_Team_ValueInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("€5/Nutzer/Mo. enthaltene Credits")
	return /** @type {LocalizedString} */ ("€5/user/mo included credits")
});